import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

export default function FinalCTA() {
  return (
    <section
      data-testid="final-cta-section"
      className="relative bg-[#080808] py-28 md:py-40 border-t border-white/10 overflow-hidden"
    >
      <div className="absolute left-1/2 top-0 -translate-x-1/2 w-[800px] h-[400px] rounded-full bg-[#D4AF37]/8 blur-[160px] pointer-events-none" />
      <div className="relative max-w-5xl mx-auto px-6 md:px-12 text-center">
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="font-display text-4xl md:text-6xl lg:text-7xl font-black tracking-tighter text-[#F4F4F0] leading-[0.98]"
        >
          Pay as you go.<br />
          <span className="text-[#D4AF37]">Or go all-in with a membership.</span>
        </motion.h2>
        <p className="mt-8 text-lg md:text-xl text-[#A0A0A0] max-w-2xl mx-auto leading-relaxed">
          Either way, you ship polished, business-grade videos — fast. Built by Young Black Man Incorporated Studios for creators, musicians and small businesses.
        </p>
        <div className="mt-12 flex flex-col sm:flex-row gap-4 justify-center items-stretch sm:items-center">
          <Link
            to="/register"
            data-testid="final-cta-primary"
            className="group inline-flex items-center justify-center gap-2 bg-[#D4AF37] text-[#080808] font-bold px-10 py-4 hover:bg-[#F0C84B] transition-colors"
          >
            Start Free Trial
            <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5" />
          </Link>
          <a
            href="#pricing"
            data-testid="final-cta-secondary"
            className="inline-flex items-center justify-center text-[#F4F4F0] border border-[#2A2A2A] hover:border-[#D4AF37] px-10 py-4 transition-colors"
          >
            View All Plans
          </a>
        </div>
      </div>
    </section>
  );
}
